<div class="relative flex h-full w-full flex-row" aria-labelledby="report-schedule-title" role="dialog"
  aria-modal="true">
  <div
    class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden bg-zinc-200/40 backdrop-blur-md dark:bg-zinc-900/60">
    <button type="button" (click)="close()" aria-label="Close"
      class="btn-shout-fab-secondary absolute top-2 left-2 z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-5 sm:size-6" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>

    <div class="primary-card-container relative flex h-[90%] w-[90%] flex-col gap-y-2 overflow-hidden p-2">
      <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
        <div
          style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
          class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
        </div>
      </div>

      <form class="relative z-10 flex h-full min-h-0 w-full flex-col" (submit)="save($event)">
        <div
          class="flex w-full shrink-0 flex-row items-center justify-between border-b border-zinc-200 pb-2 dark:border-zinc-800">
          <div class="flex min-w-0 items-center">
            <div class="shrink-0">
              <div
                class="flex size-12 items-center justify-center rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6"
                  aria-hidden="true">
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                </svg>
              </div>
            </div>
            <div class="ml-4 min-w-0">
              <h2 id="report-schedule-title" class="text-base font-semibold text-gray-900 dark:text-white">{{ schedule()
                ? 'Edit weekly report' : 'Schedule weekly report' }}</h2>
              <p class="truncate text-sm text-gray-500 dark:text-gray-400">{{ briefName() }}</p>
            </div>
          </div>
        </div>



        <div class="flex min-h-0 w-full flex-1 flex-col overflow-y-auto py-4 scrollbar-transparent px-4">

          <div class="mx-auto grid w-full max-w-4xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <fieldset class="sm:col-span-6">
              <legend class="block text-sm/6 font-medium text-gray-900 dark:text-white">Day of week</legend>
              <div class="mt-2 flex min-w-0 flex-wrap gap-2">
                @for (day of weekdays; track day.value) {
                <button type="button" [class]="dayButtonClass(day.value)"
                  [attr.aria-pressed]="form.controls.dayOfWeek.value === day.value" (click)="selectDay(day.value)">{{
                  day.label }}</button>
                }
              </div>
            </fieldset>

            <fieldset class="sm:col-span-6">
              <legend class="block text-sm/6 font-medium text-gray-900 dark:text-white">Time of Day</legend>
              <div class="mt-2 flex min-w-0 flex-wrap gap-2">
                @for (time of times; track time.value) {
                <button type="button" [class]="timeButtonClass(time.value)"
                  [attr.aria-pressed]="form.controls.timeOfDay.value === time.value" (click)="selectTime(time.value)">{{
                  time.label }}</button>
                }
              </div>
            </fieldset>

            <div class="sm:col-span-6">
              <label for="report-zone" class="block text-sm/6 font-medium text-gray-900 dark:text-white">Time zone</label>
              <el-select id="report-zone" name="timezone" [value]="form.controls.timezone.value" class="mt-2 block">
                <button type="button"
                  class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-indigo-500">
                  <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">{{ form.controls.timezone.value }}</el-selectedcontent>
                  <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                    class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                    <path
                      d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                      clip-rule="evenodd" fill-rule="evenodd" />
                  </svg>
                </button>
                <el-options anchor="bottom start" popover
                  class="max-h-60 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                  <div class="sticky top-0 z-10 bg-white px-2 py-2 dark:bg-gray-800" (mousedown)="keepZoneSearchOpen($event)" (click)="keepZoneSearchOpen($event)" (keydown)="keepZoneSearchOpen($event)">
                    <label class="sr-only" for="report-zone-filter">Search time zones</label>
                    <input id="report-zone-filter" type="search" [class]="fieldClass" placeholder="Search time zones"
                      [value]="zoneQuery()" (input)="onZoneInput($event)" (keydown)="keepZoneSearchOpen($event)" />
                  </div>
                  @for (zone of filteredZones(); track zone) {
                  <el-option [value]="zone" (click)="selectZone(zone)"
                    class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-indigo-600 focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-indigo-500">
                    <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{ zone }}</span>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden dark:text-indigo-400">
                      <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                        <path
                          d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                          clip-rule="evenodd" fill-rule="evenodd" />
                      </svg>
                    </span>
                  </el-option>
                  } @empty {
                  <p class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">No matching time zones</p>
                  }
                </el-options>
              </el-select>
            </div>

            <div class="sm:col-span-6">
              <label class="block text-sm/6 font-medium text-gray-900 dark:text-white"
                for="report-recipient">Recipients</label>
              <div class="mt-2 flex gap-2">
                <input id="report-recipient" type="email" [class]="recipientFieldClass" placeholder="name@company.com"
                  [formControl]="form.controls.recipientDraft" />
                <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary shrink-0"
                  (click)="addRecipient()">Add</button>
              </div>
              @if (recipientError()) {
              <p class="mt-2 text-sm text-rose-600">{{ recipientError() }}</p>
              }
              <ul class="mt-3 flex flex-wrap gap-2">
                @for (email of recipients(); track email) {
                <li>
                  <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary"
                    (click)="removeRecipient(email)" [attr.aria-label]="'Remove ' + email">{{ email }} ×</button>
                </li>
                }
              </ul>
            </div>

            <fieldset class="sm:col-span-6">
              <legend class="block text-sm/6 font-medium text-gray-900 dark:text-white">Include sections</legend>
              <div class="mt-2 border-t border-b border-gray-200 dark:border-white/10">
                <div class="divide-y divide-gray-200 dark:divide-white/10">
                  <div class="relative flex gap-3 pt-3.5 pb-4">
                    <div class="min-w-0 flex-1 text-sm/6">
                      <label for="section-overview" class="font-medium text-gray-900 dark:text-white">Brief overview</label>
                      <p id="section-overview-description" class="text-gray-500 dark:text-gray-400">Objective, key messages, and brief facts.</p>
                    </div>
                    <div class="flex h-6 shrink-0 items-center">
                      <div class="group grid size-4 grid-cols-1">
                        <input id="section-overview" type="checkbox" [formControl]="form.controls.overview"
                          aria-describedby="section-overview-description"
                          class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-indigo-500 dark:checked:bg-indigo-500 dark:indeterminate:border-indigo-500 dark:indeterminate:bg-indigo-500 dark:focus-visible:outline-indigo-500 dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                          class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                          <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-checked:opacity-100" />
                          <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="relative flex gap-3 pt-3.5 pb-4">
                    <div class="min-w-0 flex-1 text-sm/6">
                      <label for="section-stats" class="font-medium text-gray-900 dark:text-white">Headline stats</label>
                      <p id="section-stats-description" class="text-gray-500 dark:text-gray-400">Views, engagements, audience, and post totals.</p>
                    </div>
                    <div class="flex h-6 shrink-0 items-center">
                      <div class="group grid size-4 grid-cols-1">
                        <input id="section-stats" type="checkbox" [formControl]="form.controls.stats"
                          aria-describedby="section-stats-description"
                          class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-indigo-500 dark:checked:bg-indigo-500 dark:indeterminate:border-indigo-500 dark:indeterminate:bg-indigo-500 dark:focus-visible:outline-indigo-500 dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                          class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                          <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-checked:opacity-100" />
                          <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="relative flex gap-3 pt-3.5 pb-4">
                    <div class="min-w-0 flex-1 text-sm/6">
                      <label for="section-top" class="font-medium text-gray-900 dark:text-white">Top performers</label>
                      <p id="section-top-description" class="text-gray-500 dark:text-gray-400">The posts with the most views in this period.</p>
                    </div>
                    <div class="flex h-6 shrink-0 items-center">
                      <div class="group grid size-4 grid-cols-1">
                        <input id="section-top" type="checkbox" [formControl]="form.controls.topPerformers"
                          aria-describedby="section-top-description"
                          class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-indigo-500 dark:checked:bg-indigo-500 dark:indeterminate:border-indigo-500 dark:indeterminate:bg-indigo-500 dark:focus-visible:outline-indigo-500 dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                          class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                          <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-checked:opacity-100" />
                          <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="relative flex gap-3 pt-3.5 pb-4">
                    <div class="min-w-0 flex-1 text-sm/6">
                      <label for="section-posts" class="font-medium text-gray-900 dark:text-white">Every post + video</label>
                      <p id="section-posts-description" class="text-gray-500 dark:text-gray-400">Each post that went live, with its video.</p>
                    </div>
                    <div class="flex h-6 shrink-0 items-center">
                      <div class="group grid size-4 grid-cols-1">
                        <input id="section-posts" type="checkbox" [formControl]="form.controls.posts"
                          aria-describedby="section-posts-description"
                          class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 dark:border-white/10 dark:bg-white/5 dark:checked:border-indigo-500 dark:checked:bg-indigo-500 dark:indeterminate:border-indigo-500 dark:indeterminate:bg-indigo-500 dark:focus-visible:outline-indigo-500 dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                        <svg viewBox="0 0 14 14" fill="none"
                          class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25 dark:group-has-disabled:stroke-white/25">
                          <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-checked:opacity-100" />
                          <path d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="opacity-0 group-has-indeterminate:opacity-100" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (sectionError()) {
              <p class="mt-2 text-sm text-rose-600">{{ sectionError() }}</p>
              }
            </fieldset>

            @if (nextRunLocal()) {
            <p class="text-sm/6 text-gray-600 sm:col-span-6 dark:text-gray-400">{{ nextRunLocal() }}</p>
            }
          </div>
        </div>

        <div
          class="flex w-full shrink-0 flex-row items-center justify-between border-t border-zinc-200 pt-2 dark:border-zinc-800">
          <div class="flex items-center gap-2">
            <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="close()">Cancel</button>
            @if (schedule()) {
            <button type="button" class="btn-shout btn-shout-sm btn-shout-alert" (click)="stop()"
              [disabled]="saving()">Stop sending</button>
            }
          </div>

          @if (saving()) {
          <p
            class="m-0 inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
            <svg aria-hidden="true" class="h-5 w-5 animate-spin fill-primary text-gray-200 dark:text-gray-300"
              viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
            </svg>
            Saving schedule...
          </p>
          } @else {
          <button type="button" class="btn-shout btn-shout-sm btn-shout-primary" (click)="save()">
            Save schedule
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5"
              aria-hidden="true">
              <path d="M8 2v4" />
              <path d="M16 2v4" />
              <rect width="18" height="18" x="3" y="4" rx="2" />
              <path d="M3 10h18" />
              <path d="m9 16 2 2 4-4" />
            </svg>
          </button>
          }
        </div>
      </form>

      <div aria-hidden="true"
        class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
        <div
          style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
          class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
        </div>
      </div>
    </div>
  </div>
</div>